module.exports = __webpack_public_path__ + "static/eat-bitter-zine-web-a76234b8277bb72e31aec0f569bb906e.jpg";